import { render, staticRenderFns } from "./memberShareRecord.vue?vue&type=template&id=6c6197be&scoped=true"
import script from "./memberShareRecord.vue?vue&type=script&lang=js"
export * from "./memberShareRecord.vue?vue&type=script&lang=js"
import style0 from "./memberShareRecord.vue?vue&type=style&index=0&id=6c6197be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6197be",
  null
  
)

export default component.exports